module.exports = __webpack_public_path__ + "static/media/bean_burst_faint_br.321e52c8.png";